import { render, staticRenderFns } from "./remarks.vue?vue&type=template&id=a0151590&scoped=true&"
import script from "./remarks.vue?vue&type=script&lang=js&"
export * from "./remarks.vue?vue&type=script&lang=js&"
import style0 from "./remarks.vue?vue&type=style&index=0&id=a0151590&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0151590",
  null
  
)

export default component.exports